import { render, staticRenderFns } from "./PrivacyCheckbox.vue?vue&type=template&id=2256ecfa"
import script from "./PrivacyCheckbox.vue?vue&type=script&lang=js"
export * from "./PrivacyCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports